export default __webpack_public_path__ + "static/logo-b0e11c6340714d9de326a8aba3f67965.png";